import React, { useEffect, useState } from "react";
import "./Conversation.css";
import PageTitleSection from "../../components/reusable/PageTitleSection/PageTitleSection";
import BIDButton from "../../components/reusable/BIDButton/BIDButton";
import { Divider, Select, Typography } from "antd";
import { COUNTRY_OPTIONS } from "../../utils/constants/countryOptions";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as ConversationIcon } from "../../images/icons/conversation.svg";
import { ReactComponent as SentimentIcon } from "../../images/icons/sentiment.svg";
import { ReactComponent as XenophobiaIcon } from "../../images/icons/xenophobia.svg";
import Tweets from "../../components/graphs/Tweets";
import News from "../../components/graphs/News";
import PrincipalTopics from "../../components/graphs/PrincipalTopics";
import ConversationTransformation from "../../components/graphs/ConversationTransformation";
import ActivityByCity from "../../components/graphs/ActivityByCity";
import MigratorySentiment from "../../components/graphs/MigratorySentiment";
import ReactionsToInstiturions from "../../components/graphs/ReactionsToInstitutions";
import XenoPrevalence from "../../components/graphs/XenoPrevalence";
import XenoAccounts from "../../components/graphs/XenoAccounts";
import Reach from "../../components/graphs/Reach";
import MigratorySentimentbyTopic from "../../components/graphs/SentimentByTopic";
//import { DownloadReportButton } from "../../components/reusable/DownloadReportButton/DownloadReportButton";
import TEXT from "../../utils/text/conversation.json";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";
import miscText from "../../utils/text/misc.json";
import glossaryText from "../../utils/text/glossary.json";
import { QuestionCircleOutlined } from "@ant-design/icons";
import GlossaryModal from "../../components/GlossaryModal/GlossaryModal";
import BIDModal from "../../components/reusable/BIDModal/BIDModal";

const { Option } = Select;
const { Paragraph } = Typography;

/**
 *
 * @returns Data page
 */
export default function Conversation() {
  let navigate = useNavigate();

  const { country, openGlossary } = useParams();
  const { language, languagePath } = useCurrentLanguage();

  const [selectedCountry, setSelectedCountry] = useState(country);
  const [isConvSelected, setIsConvSelected] = useState(false);
  const [isMigSentSelected, setIsMigSentSelected] = useState(false);
  const [isXenoSelected, setIsXenoSelectedyy] = useState(false);
  const [openModal, setOpenModal] = useState(openGlossary === "glosario");

  async function handleSelectChange(newValue) {
    navigate(languagePath + "/conversacion/" + newValue, { replace: false });
    setSelectedCountry(newValue);
  }

  function handleCancel() {
    setOpenModal(false);
  }

  function showSection(section) {
    if (!isConvSelected && !isMigSentSelected && !isXenoSelected) return true;

    switch (section) {
      case "conv":
        return isConvSelected;
      case "sent":
        return isMigSentSelected;
      case "xeno":
        return isXenoSelected;
      default:
        return true;
    }
  }

  function convOnClick() {
    setIsConvSelected(!isConvSelected);
  }

  function sentOnClick() {
    setIsMigSentSelected(!isMigSentSelected);
  }

  function xenoOnClick() {
    setIsXenoSelectedyy(!isXenoSelected);
  }

  useEffect(() => {
    setSelectedCountry(country);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [country]);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: "pageview",
    });
  }, []);

  return (
    <div className="data-page-container">
      <div className="data-page-title">
        <PageTitleSection
          title={TEXT["title"][language]}
          descriptionParagraphs={TEXT["description"][language]}
          image={"data.png"}
          postCTAContent={
            <Paragraph
              className="gbi"
              style={{
                fontSize: "10px",
                marginTop: "20px",
              }}
            >
              {/* {(language === "en" ? "Source: " : "Fuente: ") +
                miscText["source"][language] +
                ", " +
                new Date().getFullYear()} */}
            </Paragraph>
          }
          callToActionElement={
            <div className="data-page-report-button">
              <a
                href="https://publications.iadb.org/es/mas-alla-de-las-fronteras-estigmas-y-desafios-en-la-integracion-de-las-mujeres-migrantes-en-america"
                target={"_blank"}
                rel="noreferrer"
              >
                <BIDButton
                  text={miscText["downloadLatestReport"][language]}
                  type={"light"}
                  size={"medium"}
                />
              </a>
            </div>
          }
        />
      </div>
      <data className="data-page-content">
        <div className="data-page-select-container">
          <div className="data-page-select-content">
            <div className="data-page-search-caption">
              <strong>{TEXT["searchByCountry"][language]}</strong>
            </div>
            <Select
              className="data-page-select"
              value={selectedCountry ?? "LAC"}
              onChange={handleSelectChange}
            >
              {COUNTRY_OPTIONS.map((country, key) => {
                return (
                  <Option key={key} value={country.code}>
                    {language === "en"
                      ? country.country_text_en
                      : country.country_text}
                  </Option>
                );
              })}
            </Select>
          </div>
        </div>
        <h1 className="data-page-country-title">
          {
            COUNTRY_OPTIONS.find((co) => selectedCountry === co.code)[
              language === "en" ? "country_text_en" : "country_text"
            ]
          }
        </h1>
        {/* <div className={"data-page-summary-container"}>
          <div className={"data-page-summary"}>
            <DownloadReportButton country={country} />
          </div>
        </div> */}
        <div className="data-page-index">
          <div
            className={
              "data-page-index-button" +
              (isConvSelected ? " darker-selected" : "")
            }
          >
            <BIDButton
              size={"medium"}
              text={
                <div className="data-page-logo-container">
                  <ConversationIcon />
                  {TEXT["conversation"][language]}
                </div>
              }
              onClick={convOnClick}
            />
          </div>
          <div
            className={
              "data-page-index-button" +
              (isMigSentSelected ? " darker-selected" : "")
            }
          >
            <BIDButton
              size={"medium"}
              text={
                <div className="data-page-logo-container">
                  <SentimentIcon />
                  {TEXT["sentiment"][language]}
                </div>
              }
              onClick={sentOnClick}
            />
          </div>
          <div
            className={
              "data-page-index-button" +
              (isXenoSelected ? " darker-selected" : "")
            }
          >
            <BIDButton
              size={"medium"}
              text={
                <div className="data-page-logo-container">
                  <XenophobiaIcon />
                  {TEXT["xenophobia"][language]}
                </div>
              }
              onClick={xenoOnClick}
            />
          </div>
        </div>
        <Divider className="divider-full-screen" />
        <div className="data-page-definitions">
          <GlossaryModal>
            <div className="glossary-button">
              <QuestionCircleOutlined
                style={{
                  marginTop: "5px",
                  color: "var(--blue-primary)",
                  textAlign: "left",
                }}
              />{" "}
              {miscText["modalButtonText"][language]}
            </div>
          </GlossaryModal>
        </div>

        <div className="data-page-graphs">
          <div
            id="conversation-section"
            className={
              "data-page-section" +
              (showSection("conv") ? "" : " data-page-hidden")
            }
          >
            <div className="data-page-section-title">
              {TEXT["conversation"][language]}
            </div>
            <div id="tweets" className="full-screen">
              <Tweets selectedCountry={selectedCountry} colorRBG={"#555555"} />
            </div>
            {selectedCountry ? (
              <div id="news" className="full-screen">
                <News selectedCountry={selectedCountry} colorRBG={"#555555"} />
              </div>
            ) : null}
            <div id="principal-topics" className="full-screen">
              <PrincipalTopics
                selectedCountry={selectedCountry}
                colorRBG={"#555555"}
              />
            </div>
            <div id="evolution" className="full-screen">
              <ConversationTransformation
                selectedCountry={selectedCountry}
                colorRBG={"#555555"}
              />
            </div>
            {selectedCountry !== "LAC" ? (
              <div id="activity-by-city" className="full-screen">
                <ActivityByCity
                  selectedCountry={selectedCountry}
                  colorRBG={"#555555"}
                />
              </div>
            ) : null}
          </div>
          <div
            id="sentiment-section"
            className={
              "data-page-section" +
              (showSection("sent") ? "" : " data-page-hidden")
            }
          >
            <div className="data-page-section-title">
              {TEXT["sentiment"][language]}
            </div>
            <div id="mig-sentiment" className="full-screen">
              <MigratorySentiment
                selectedCountry={selectedCountry}
                colorRBG={"#555555"}
              />
            </div>
            <div id="mig-sentiment-topic" className="full-screen">
              <MigratorySentimentbyTopic
                selectedCountry={selectedCountry}
                colorRBG={"#555555"}
              />
            </div>
            <div id="reactions" className="full-screen">
              <ReactionsToInstiturions
                selectedCountry={selectedCountry}
                colorRBG={"#555555"}
              />
            </div>
          </div>
          <div
            id="xeno-section"
            className={
              "data-page-section" +
              (showSection("xeno") ? "" : " data-page-hidden")
            }
          >
            <div className="data-page-section-title">
              {TEXT["xenophobia"][language]}
            </div>
            <div id="xeno-prevalence" className="full-screen">
              <XenoPrevalence
                selectedCountry={selectedCountry}
                colorRBG={"#555555"}
              />
            </div>
            <div id="xeno-accounts" className="full-screen">
              <XenoAccounts
                selectedCountry={selectedCountry}
                colorRBG={"#555555"}
              />
            </div>
            <div id="reach" className="full-screen">
              <Reach selectedCountry={selectedCountry} colorRBG={"#555555"} />
            </div>
          </div>
        </div>
      </data>

      <BIDModal
        title={TEXT["title"][language]}
        visible={openModal}
        onCancel={handleCancel}
      >
        {glossaryText["terms"].map((term, key) => {
          return (
            <p key={key}>
              <strong>{term["term"][language]}: </strong>
              {term["definition"][language]}
            </p>
          );
        })}
      </BIDModal>
    </div>
  );
}
